// Product Purchase Type (OTP/Membership) enum
export enum ProductPurchaseOption {
  oneTimePurchase = 'otp',
  membership = 'membership',
  x = 'x',
}

// Product Code ENUM
export enum ProductPurchaseType {
  // IN otp
  otp_2_week = 'uh-m1-two-week',
  otp_4_week = 'uh-m1-four-week',
  otp_12_week = 'uh-m1-twelve-week',
  otp_24_week = 'uh-m1-twenty-four-week',
  otp_1_year = 'uh-m1-year',

  // IN subscription
  membership_1_sensor_month = 'uh-m1-1-sensor-month',
  membership_2_sensor_month = 'uh-m1-2-sensor-month',

  // IN otp x
  otp_2_week_x = 'uh-m1-two-week-x',
  otp_12_week_x = 'uh-m1-twelve-week-x',
  otp_24_week_x = 'uh-m1-twenty-four-week-x',
  otp_1_year_x = 'uh-m1-year-x',

  // IN  otp referral
  otp_2_week_ref = 'uh-m1-two-week_ref',
  otp_4_week_ref = 'uh-m1-four-week_ref',
  otp_12_week_ref = 'uh-m1-twelve-week_ref',
  otp_24_week_ref = 'uh-m1-twenty-four-week_ref',
  otp_1_year_ref = 'uh-m1-year_ref',

  // IN subscription referral
  membership_1_sensor_month_ref = 'uh-m1-1-sensor-month-ref',
  membership_2_sensor_month_ref = 'uh-m1-2-sensor-month-ref',

  // IN otp
  otp_2_week_campaign = 'uh-m1-two-week-campaign',
  otp_4_week_campaign = 'uh-m1-four-week-campaign',

  // IN otp recommended
  otp_2_week_select = 'uh-m1-two-week-select',
  otp_12_week_select = 'uh-m1-twelve-week-select',
  otp_24_week_select = 'uh-m1-twenty-four-week-select',
  otp_1_year_select = 'uh-m1-year-select',

  //US Launch
  special_1_month_us = 'uh-m1-one-month-us-special',
  special_3_month_us = 'uh-m1-three-month-us-special',
  special_1_year_us = 'uh-m1-year-us-special',

  //US otp
  otp_1_month_us = 'uh-m1-one-month-us',
  otp_3_month_us = 'uh-m1-three-month-us',
  otp_1_year_us = 'uh-m1-year-us',

  //US subscription
  membership_1_sensor_month_us = 'uh-m1-1-sensor-month-us',

  // AE otp
  otp_1_month_ae = 'uh-m1-one-month-ae',
  otp_3_month_ae = 'uh-m1-three-month-ae',
  otp_6_month_ae = 'uh-m1-six-month-ae',
  otp_1_year_ae = 'uh-m1-year-ae',

  // AE X otp
  otp_1_month_ae_x = 'uh-m1-one-month-ae-x',
  otp_3_month_ae_x = 'uh-m1-three-month-ae-x',
  otp_6_month_ae_x = 'uh-m1-six-month-ae-x',
  otp_1_year_ae_x = 'uh-m1-year-ae-x',

  // AE subscription
  membership_1_sensor_month_ae = 'ul-m1-1-sensor-month-ae',
  membership_1_sensor_month_ae_ref = 'ul-m1-1-sensor-month-ae-ref',

  // AE otp referral
  otp_1_month_ae_ref = 'uh-m1-one-month-ae-ref',
  otp_3_month_ae_ref = 'uh-m1-three-month-ae-ref',
  otp_6_month_ae_ref = 'uh-m1-six-month-ae-ref',
  otp_1_year_ae_ref = 'uh-m1-year-ae-ref',

  //AE otp affiliate
  otp_3_month_ae_affiliate = 'uh-m1-three-month-ae-affiliate',
  otp_6_month_ae_affiliate = 'uh-m1-six-month-ae-affiliate',

  //UltrahumanX
  ultrahuman_x = 'ultrahuman_x',
  ultrahuman_x_ae = 'ultrahuman_x_ae',
  ultrahuman_x_us = 'ultrahuman_x_us',

  //Utrahuman Intl
  otp_2_weeks_eu = 'otp_2_weeks_eu',
  otp_4_weeks_eu = 'otp_4_weeks_eu',
  otp_12_weeks_eu = 'otp_12_weeks_eu',

  //Utrahuman Intl campaign
  otp_2_weeks_eu_campaign = 'otp_2_weeks_eu_campaign',
  otp_4_weeks_eu_campaign = 'otp_4_weeks_eu_campaign',
  otp_12_weeks_eu_campaign = 'otp_12_weeks_eu_campaign',
}

const STAGING_M1_ENTRY = {
  type: ProductPurchaseOption.oneTimePurchase,
  productId: '40178299764809',
  shopifyVariantId: 'gid://shopify/ProductVariant/40178299764809',
  productType: 'cyborg',
  planId: 0,
};

const STAGING_M1_ENTRY_2 = {
  type: ProductPurchaseOption.oneTimePurchase,
  productId: '40178304876617',
  shopifyVariantId: 'gid://shopify/ProductVariant/40178304876617',
  productType: 'cyborg',
  planId: 0,
};

const STAGING_M1_ENTRY_3 = {
  type: ProductPurchaseOption.oneTimePurchase,
  productId: '40077359284297',
  shopifyVariantId: 'gid://shopify/ProductVariant/40077359284297',
  productType: 'cyborg',
  planId: 0,
};

const STAGING_M1_ENTRY_4 = {
  type: ProductPurchaseOption.oneTimePurchase,
  productId: '40178299830345',
  shopifyVariantId: 'gid://shopify/ProductVariant/40178299830345',
  productType: 'cyborg',
  planId: 0,
};

export const productShopifyIdMap =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'PRODUCTION'
    ? {
        // in here - "productId" is shoppify id or Varient Id;
        [ProductPurchaseType.otp_2_week]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142433988678',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142433988678',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_4_week]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '46462776082502',
          shopifyVariantId: 'gid://shopify/ProductVariant/46462776082502',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_12_week]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434021446',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434021446',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_24_week]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434054214',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434054214',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434086982',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434086982',
          productType: 'cyborg',
          planId: 0,
        },

        // India X
        [ProductPurchaseType.otp_2_week_x]: {
          type: ProductPurchaseOption.x,
          productId: '40566813556806',
          shopifyVariantId: 'gid://shopify/ProductVariant/40566813556806',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_12_week_x]: {
          type: ProductPurchaseOption.x,
          productId: '40596792016966',
          shopifyVariantId: 'gid://shopify/ProductVariant/40596792016966',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_24_week_x]: {
          type: ProductPurchaseOption.x,
          productId: '40566761324614',
          shopifyVariantId: 'gid://shopify/ProductVariant/40566761324614',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_x]: {
          type: ProductPurchaseOption.x,
          productId: '40566763487302',
          shopifyVariantId: 'gid://shopify/ProductVariant/40566763487302',
          productType: 'cyborg',
          planId: 0,
        },

        // India Referral
        [ProductPurchaseType.otp_2_week_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40462186283078',
          shopifyVariantId: 'gid://shopify/ProductVariant/40462186283078',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_4_week_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40376567693382',
          shopifyVariantId: 'gid://shopify/ProductVariant/40329680257094',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_12_week_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40462187855942',
          shopifyVariantId: 'gid://shopify/ProductVariant/40462187855942',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_24_week_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40462189527110',
          shopifyVariantId: 'gid://shopify/ProductVariant/40462189527110',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40462192083014',
          shopifyVariantId: 'gid://shopify/ProductVariant/40462192083014',
          productType: 'cyborg',
          planId: 0,
        },

        // india recommended
        [ProductPurchaseType.otp_2_week_select]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142433988678',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142433988678',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_12_week_select]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434021446',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434021446',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_24_week_select]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434054214',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434054214',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_select]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '45142434086982',
          shopifyVariantId: 'gid://shopify/ProductVariant/45142434086982',
          productType: 'cyborg',
          planId: 0,
        },

        // in here - "productId" is shoppify id or Varient Id;
        [ProductPurchaseType.otp_2_week_campaign]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40508689907782',
          shopifyVariantId: 'gid://shopify/ProductVariant/40508689907782',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_4_week_campaign]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40508693282886',
          shopifyVariantId: 'gid://shopify/ProductVariant/40508693282886',
          productType: 'cyborg',
          planId: 0,
        },

        // india subscription
        [ProductPurchaseType.membership_1_sensor_month]: {
          type: ProductPurchaseOption.membership,
          productId: '40459179655238',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112979,
        },
        [ProductPurchaseType.membership_2_sensor_month]: {
          type: ProductPurchaseOption.membership,
          productId: '40459180769350',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112980,
        },

        // india subscription campaign
        [ProductPurchaseType.membership_1_sensor_month_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '40459179655238',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112979,
        },

        [ProductPurchaseType.membership_2_sensor_month_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '40459180769350',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112980,
        },

        // ae things
        [ProductPurchaseType.otp_1_month_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44186161086706',
          shopifyVariantId: 'gid://shopify/ProductVariant/44186161086706',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_3_month_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44187468824818',
          shopifyVariantId: 'gid://shopify/ProductVariant/44187468824818',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_6_month_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44187592786162',
          shopifyVariantId: 'gid://shopify/ProductVariant/44187592786162',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44579593978098',
          shopifyVariantId: 'gid://shopify/ProductVariant/44579593978098',
          productType: 'cyborg',
          planId: 0,
        },

        // ae things X
        [ProductPurchaseType.otp_1_month_ae_x]: {
          type: ProductPurchaseOption.x,
          productId: '62381263847795',
          shopifyVariantId: 'gid://shopify/ProductVariant/62381263847795',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_3_month_ae_x]: {
          type: ProductPurchaseOption.x,
          productId: '62381265125747',
          shopifyVariantId: 'gid://shopify/ProductVariant/62381265125747',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_6_month_ae_x]: {
          type: ProductPurchaseOption.x,
          productId: '62381268894067',
          shopifyVariantId: 'gid://shopify/ProductVariant/62381268894067',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_ae_x]: {
          type: ProductPurchaseOption.x,
          productId: '62381272334707',
          shopifyVariantId: 'gid://shopify/ProductVariant/62381272334707',
          productType: 'cyborg',
          planId: 0,
        },

        // ae referral
        [ProductPurchaseType.otp_1_month_ae_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44186161086706',
          shopifyVariantId: 'gid://shopify/ProductVariant/44186161086706',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_3_month_ae_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44187468824818',
          shopifyVariantId: 'gid://shopify/ProductVariant/44187468824818',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_6_month_ae_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44187592786162',
          shopifyVariantId: 'gid://shopify/ProductVariant/44187592786162',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_ae_ref]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44187781071090',
          shopifyVariantId: 'gid://shopify/ProductVariant/44187781071090',
          productType: 'cyborg',
          planId: 0,
        },

        // ae subs
        [ProductPurchaseType.membership_1_sensor_month_ae]: {
          type: ProductPurchaseOption.membership,
          productId: '44218367443186',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11113114,
        },

        // ae referral subs
        [ProductPurchaseType.membership_1_sensor_month_ae_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '44218367443186',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11113114,
        },

        // ae affiliate
        [ProductPurchaseType.otp_3_month_ae_affiliate]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44342569959666',
          shopifyVariantId: 'gid://shopify/ProductVariant/44342569959666',
          productType: 'cyborg',
          planId: 0,
        },

        [ProductPurchaseType.otp_6_month_ae_affiliate]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44342611869938',
          shopifyVariantId: 'gid://shopify/ProductVariant/44342611869938',
          productType: 'cyborg',
          planId: 0,
        },

        // US Stripe OTP / special — no Shopify cart line (matches m1/US.tsx).
        [ProductPurchaseType.special_1_month_us]: {
          type: ProductPurchaseOption.x,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.special_3_month_us]: {
          type: ProductPurchaseOption.x,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.special_1_year_us]: {
          type: ProductPurchaseOption.x,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },

        // us things
        [ProductPurchaseType.otp_1_month_us]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_3_month_us]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.otp_1_year_us]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 0,
        },

        //us subscription
        [ProductPurchaseType.membership_1_sensor_month_us]: {
          type: ProductPurchaseOption.membership,
          productId: '44218367443186',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11113114,
        },

        // EU Plan
        [ProductPurchaseType.otp_2_weeks_eu]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '10950762955070',
          shopifyVariantId: 'gid://shopify/ProductVariant/49203361284414',
          productType: 'cyborg',
          planId: 0,
        },

        [ProductPurchaseType.otp_4_weeks_eu]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '10950659572030',
          shopifyVariantId: 'gid://shopify/ProductVariant/49202716934462',
          productType: 'cyborg',
          planId: 0,
        },

        [ProductPurchaseType.otp_12_weeks_eu]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '10950659604798',
          shopifyVariantId: 'gid://shopify/ProductVariant/49202716999998',
          productType: 'cyborg',
          planId: 0,
        },

        // Intl Plan Campaign
        [ProductPurchaseType.otp_2_weeks_eu_campaign]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: 'null',
          shopifyVariantId: 'gid://shopify/ProductVariant/',
          productType: 'cyborg',
          planId: 0,
        },

        [ProductPurchaseType.otp_4_weeks_eu_campaign]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: 'null',
          shopifyVariantId: 'gid://shopify/ProductVariant/40718088372284',
          productType: 'cyborg',
          planId: 0,
        },

        [ProductPurchaseType.otp_12_weeks_eu_campaign]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: 'null',
          shopifyVariantId: 'gid://shopify/ProductVariant/40718094860348',
          productType: 'cyborg',
          planId: 0,
        },

        //ultrahumanx
        [ProductPurchaseType.ultrahuman_x]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40922833158214',
          shopifyVariantId: 'gid://shopify/ProductVariant/40922833158214',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.ultrahuman_x_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '44515347759346',
          shopifyVariantId: 'gid://shopify/ProductVariant/44515347759346',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.ultrahuman_x_us]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40709660082236',
          shopifyVariantId: 'gid://shopify/ProductVariant/40709660082236',
          productType: 'cyborg',
          planId: 0,
        },
      }
    : {
        // STAGING
        // in here - "productId" is shoppify id or Varient Id;
        [ProductPurchaseType.otp_2_week]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_4_week]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_12_week]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_24_week]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year]: STAGING_M1_ENTRY_4,

        // India X
        [ProductPurchaseType.otp_2_week_x]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_12_week_x]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_24_week_x]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_x]: STAGING_M1_ENTRY_4,

        // India Referral
        [ProductPurchaseType.otp_2_week_ref]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_4_week_ref]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_12_week_ref]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_24_week_ref]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_ref]: STAGING_M1_ENTRY_4,

        // india recommended
        [ProductPurchaseType.otp_2_week_select]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_12_week_select]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_24_week_select]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_select]: STAGING_M1_ENTRY_4,

        // in here - "productId" is shoppify id or Varient Id;
        [ProductPurchaseType.otp_2_week_campaign]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_4_week_campaign]: STAGING_M1_ENTRY,

        // india subscription
        [ProductPurchaseType.membership_1_sensor_month]: {
          type: ProductPurchaseOption.membership,
          productId: '40459179655238',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112979,
        },
        [ProductPurchaseType.membership_2_sensor_month]: {
          type: ProductPurchaseOption.membership,
          productId: '40459180769350',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112980,
        },

        // india subscription campaign
        [ProductPurchaseType.membership_1_sensor_month_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '40459179655238',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112979,
        },

        [ProductPurchaseType.membership_2_sensor_month_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '40459180769350',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11112980,
        },

        // ae things
        [ProductPurchaseType.otp_1_month_ae]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_3_month_ae]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_6_month_ae]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_ae]: STAGING_M1_ENTRY_4,

        // ae things X
        [ProductPurchaseType.otp_1_month_ae_x]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_3_month_ae_x]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_6_month_ae_x]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_ae_x]: STAGING_M1_ENTRY_4,

        // ae referral
        [ProductPurchaseType.otp_1_month_ae_ref]: STAGING_M1_ENTRY,
        [ProductPurchaseType.otp_3_month_ae_ref]: STAGING_M1_ENTRY_2,
        [ProductPurchaseType.otp_6_month_ae_ref]: STAGING_M1_ENTRY_3,
        [ProductPurchaseType.otp_1_year_ae_ref]: STAGING_M1_ENTRY_4,

        // ae subs
        [ProductPurchaseType.membership_1_sensor_month_ae]: {
          type: ProductPurchaseOption.membership,
          productId: '44218367443186',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11113114,
        },

        // ae referral subs
        [ProductPurchaseType.membership_1_sensor_month_ae_ref]: {
          type: ProductPurchaseOption.membership,
          productId: '44218367443186',
          shopifyVariantId: '',
          productType: 'cyborg',
          planId: 11113114,
        },

        // ae affiliate
        [ProductPurchaseType.otp_3_month_ae_affiliate]: STAGING_M1_ENTRY,

        [ProductPurchaseType.otp_6_month_ae_affiliate]: STAGING_M1_ENTRY,

        //ultrahumanx
        [ProductPurchaseType.ultrahuman_x]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40545897939017',
          shopifyVariantId: 'gid://shopify/ProductVariant/40574829461577',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.ultrahuman_x_ae]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40545897939017',
          shopifyVariantId: 'gid://shopify/ProductVariant/40574829461577',
          productType: 'cyborg',
          planId: 0,
        },
        [ProductPurchaseType.ultrahuman_x_us]: {
          type: ProductPurchaseOption.oneTimePurchase,
          productId: '40545897939017',
          shopifyVariantId: 'gid://shopify/ProductVariant/40574829461577',
          productType: 'cyborg',
          planId: 0,
        },
      };
